// useScrollRestoration.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollRestoration() {
    const location = useLocation();

    useEffect(() => {
        // Restore scroll position when coming back
        const savedPosition = sessionStorage.getItem(`scroll-${location.key}`);

        if (savedPosition) {
            window.scrollTo(0, parseInt(savedPosition));
        } else {
            // Scroll to top for new pages
            window.scrollTo(0, 0);
        }

        // Save scroll position before leaving
        const saveScrollPosition = () => {
            sessionStorage.setItem(`scroll-${location.key}`, window.scrollY.toString());
        };

        window.addEventListener('beforeunload', saveScrollPosition);

        return () => {
            saveScrollPosition();
            window.removeEventListener('beforeunload', saveScrollPosition);
        };
    }, [location]);
}